import React from 'react';
import  HighlightOff  from '@material-ui/icons/HighlightOff';
import {makeStyles} from '@material-ui/styles';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Button } from '@material-ui/core';


const useStyles = makeStyles({
        title: {
            background: '#08090a',
            padding: '4px 16px',
        
            '& .MuiTypography-root': {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              color: '#fff'
            },
        
            '& .MuiIconButton-root': {
              color: '#fff'
            }
          },
})

const Modal = (props) => {
    const {onClose, onConfirm, open, title} = props;
    const styles = useStyles();

    return (
        <Dialog
            fullWidth
            open={open}
            onClose={onClose}
        >
            <DialogTitle className={styles.title}>
                <span>{title}</span>
                <IconButton disableRipple onClick={onClose}>
                    <HighlightOff />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText style={{margin:'0px'}}>
                    {props.children}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                    <Button disableRipple variant='contained' onClick={onClose} >
                        Cancel
                    </Button>
                { onConfirm && (<Button disableRipple color="primary" variant='contained' onClick={onConfirm} >
                    Confirm
                </Button>) }
            </DialogActions>
        </Dialog>

    )
}

export default Modal;